import { render } from "./ProductForm.vue?vue&type=template&id=b22dfba4&scoped=true&ts=true"
import script from "./ProductForm.vue?vue&type=script&lang=ts"
export * from "./ProductForm.vue?vue&type=script&lang=ts"

import "./ProductForm.vue?vue&type=style&index=0&id=b22dfba4&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22dfba4"]])

export default __exports__